import { ContactPayload} from '@capacitor-community/contacts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState:ContactPayload[] = [];

const userContacts = createSlice({
  name: 'userContacts',
  initialState,
  reducers: {
    setUserContacts(state,action:PayloadAction<ContactPayload[]>){
      return action.payload;
    }
  },

});

// Reducer
export default userContacts.reducer;

// Actions
export const {setUserContacts} = userContacts.actions;

